import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import Contents from "./components/Contents";
import Header from "./components/Header";
import bg from "./images/bg1.jpg";
import FoodItemPage from "./components/Pages/FoodItem/FoodItemPage";

function App() {
  return (
    <div>
      <img
        src={bg}
        className="bgimage"
        alt=""
        style={{ background: "black" }}
      />
      <BrowserRouter>
      <Header />
        <Routes>
          <Route path="/" element={<Contents />} />
          <Route path="food/:id" element={<FoodItemPage />} />
        </Routes>
      </BrowserRouter>
    </div>
    // <div style={{ backgroundImage: `url(${bg})` }} className="bg">
    //   {/* <img src={bg} className="bgimage"/> */}
    //   <Header/>

    // </div>
  );
}

export default App;
